import UserTermsModal from './UserTermsModal';

export default UserTermsModal;
